import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-2 p-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "ID: ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Username: ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Email: ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_button_wrapper = _resolveComponent("button-wrapper")!
  const _component_form_wrapper = _resolveComponent("form-wrapper")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    "is-displayed": true,
    "no-padding": true,
    title: 'User information',
    onToggleModal: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('toggle-modal')))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_form_wrapper, { "is-form-in-modal": true }, {
        default: _withCtx(() => [
          _createElementVNode("form", {
            onSubmit: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('toggle-modal')), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("p", null, [
                _hoisted_2,
                _createTextVNode(_toDisplayString(_ctx.selectedData.id), 1)
              ]),
              _createElementVNode("p", null, [
                _hoisted_3,
                _createTextVNode(_toDisplayString(_ctx.selectedData.username), 1)
              ]),
              _createElementVNode("p", null, [
                _hoisted_4,
                _createTextVNode(_toDisplayString(_ctx.selectedData.email), 1)
              ])
            ]),
            _createVNode(_component_button_wrapper, { text: 'Close' })
          ], 32)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}